"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL = 2;
exports.MALE = 1;
exports.FEMALE = 0;
var Gender = (function () {
    function Gender() {
    }
    Gender.fromString = function (genderString) {
        if (genderString.toUpperCase().charAt(0) === "M") {
            return exports.MALE;
        }
        else if (genderString.toUpperCase().charAt(0) === "F") {
            return exports.FEMALE;
        }
        else if (genderString.toUpperCase().charAt(0) === "A") {
            return exports.ALL;
        }
        else {
            return Number.NaN;
        }
    };
    Gender.toString = function (code) {
        if (code === exports.MALE) {
            return "male";
        }
        else if (code === exports.FEMALE) {
            return "female";
        }
        else if (code === exports.ALL) {
            return "all";
        }
        else {
            return "ERROR";
        }
    };
    return Gender;
}());
exports.Gender = Gender;
//# sourceMappingURL=Gender.js.map